const firebaseConfig = {
    apiKey: "AIzaSyCjRQJp_Y_os8S_agyLRUx-RfPBEI6fHyY",
    authDomain: "event-studio-1b7c5.firebaseapp.com",
    projectId: "event-studio-1b7c5",
    storageBucket: "event-studio-1b7c5.appspot.com",
    messagingSenderId: "510288020212",
    appId: "1:510288020212:web:efd630543f25c968fa94a1"
  };
  export default firebaseConfig;